import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown } from '@fortawesome/free-solid-svg-icons'

export type FilterDropdownOption = {
  value: string
  label: string
  swatchColor?: string
}

export function FilterDropdown({
  label,
  options,
  selected,
  onToggle,
}: {
  label: string
  options: FilterDropdownOption[]
  selected: readonly string[]
  onToggle: (value: string) => void
}) {
  const count = selected.length
  const selectedSet = new Set(selected)

  return (
    <div className="dropdown">
      <div
        tabIndex={0}
        role="button"
        className={`btn btn-xs gap-1.5 normal-case ${
          count > 0 ? 'btn-primary' : 'btn-ghost border border-base-300'
        }`}
        aria-haspopup="listbox"
        aria-label={`${label} filter${count > 0 ? `, ${count} selected` : ''}`}
      >
        {label}
        {count > 0 ? (
          <span className="badge badge-xs h-4 min-h-0 px-1 font-semibold badge-neutral bg-base-100 text-base-content">
            {count}
          </span>
        ) : null}
        <FontAwesomeIcon icon={faChevronDown} className="text-[9px] opacity-70" />
      </div>
      <ul
        tabIndex={0}
        role="listbox"
        aria-multiselectable
        aria-label={`${label} options`}
        className="dropdown-content z-40 mt-1 grid max-h-56 w-[min(20rem,calc(100vw-2rem))] grid-cols-[repeat(auto-fit,minmax(9rem,1fr))] gap-0.5 overflow-x-hidden overflow-y-auto rounded-xl border-2 border-base-300 bg-base-100 p-1 shadow-lg"
        onMouseDown={(e) => {
          // Keep focus so the dropdown stays open while toggling checkboxes.
          e.preventDefault()
        }}
      >
        {options.length === 0 ? (
          <li className="px-2 py-1.5 text-xs text-base-content/50">No options</li>
        ) : (
          options.map((opt) => {
            const checked = selectedSet.has(opt.value)
            return (
              <li key={opt.value} role="option" aria-selected={checked} className="min-w-0">
                <label className="flex min-w-0 cursor-pointer items-center gap-2 rounded-lg px-2 py-1.5 text-xs hover:bg-base-200">
                  <input
                    type="checkbox"
                    className="checkbox checkbox-xs checkbox-primary shrink-0"
                    checked={checked}
                    onChange={() => onToggle(opt.value)}
                  />
                  {opt.swatchColor ? (
                    <span
                      className="h-2 w-2 shrink-0 rounded-full border border-black/20"
                      style={{ backgroundColor: opt.swatchColor }}
                      aria-hidden
                    />
                  ) : null}
                  <span className="min-w-0 flex-1 truncate">{opt.label}</span>
                </label>
              </li>
            )
          })
        )}
      </ul>
    </div>
  )
}
